module.exports = __webpack_public_path__ + "img/logo-icon-essilor-white.83766a10.svg";